export enum PointerActionType {
    DragOrSelect = 'DragOrSelect',
    Drag = 'Drag',
    Resize = 'Resize',
    Rotate  = 'Rotate',
    DrawSelection = 'DrawSelection',
    DrawingSelection = 'DrawingSelection'
}
